<template>
  <div class="account-income">
    <pageTitle :pageTitle="$t('lang.k_130001')">
      <div slot="content">
        {{ $t('lang.k_130002') }}
        <br />
        {{ $t('lang.k_130003') }}
        <br />
        {{ $t('lang.k_130004') }}
        <br />
        {{ $t('lang.k_130005') }}
      </div>
    </pageTitle>
    <div class="detail" @click="accountDetail">{{ $t('lang.k_130006') }}</div>
    <vh-row :gutter="10">
      <vh-col :span="12" style="padding-right: 0">
        <div class="live-come">
          <h3>{{ $t('lang.k_130007') }}</h3>
          <div class="live-all">
            <div class="all-come">
              <p>
                {{ $t('lang.k_130008') }}
                <span class="moneyUnit">{{ $t('lang.k_130009') }}</span>
              </p>
              <h1 class="custom-font-barlow">{{ incomeInfo.live_income | formatMoney }}</h1>
            </div>
            <div class="all-come">
              <p>
                {{ $t('lang.k_130010') }}
                <span class="moneyUnit">{{ $t('lang.k_130009') }}</span>
                <span class="withdraw" @click="cash('live')">
                  {{ incomeInfo.in_live_withdraw ? $t('lang.k_130011') : $t('lang.k_130012') }}
                </span>
                <vh-tooltip effect="dark" placement="right" v-tooltipMove>
                  <div slot="content">
                    {{ $t('lang.k_130013') }}
                    <br />
                    {{ $t('lang.k_130014') }}
                    <br />
                    {{ $t('lang.k_130015') }}
                    <br />
                    {{ $t('lang.k_130016') }}
                    <br />
                    <!-- prettier-ignore -->
                    {{ $t('lang.k_130017') }}
                    <br />
                    {{ $t('lang.k_130018') }}
                    <br />
                    {{ $t('lang.k_130019') }}
                    <br />
                    {{ $t('lang.k_130020') }}
                    <br />
                    {{ $t('lang.k_130021') }}
                    <br />
                    {{ $t('lang.k_130022') }}
                    <br />
                    {{ $t('lang.k_130023') }}
                    <br />
                    {{ $t('lang.k_130024') }}
                    <br />
                    {{ $t('lang.k_130025') }}
                  </div>
                  <i class="iconfont-v3 saasicon_help_m"></i>
                </vh-tooltip>
              </p>
              <h1 class="custom-font-barlow">{{ incomeInfo.live_balance | formatMoney }}</h1>
            </div>
          </div>
        </div>
      </vh-col>
      <vh-col :span="12" style="padding-left: 0">
        <div class="money-come">
          <h3>{{ $t('lang.k_130026') }}</h3>
          <div class="live-all">
            <div class="all-come">
              <p>
                {{ $t('lang.k_130008') }}
                <span class="moneyUnit">{{ $t('lang.k_130009') }}</span>
              </p>
              <h1 class="custom-font-barlow">{{ incomeInfo.red_packet_income | formatMoney }}</h1>
            </div>
            <div class="all-come">
              <p>
                {{ $t('lang.k_130010') }}
                <span class="moneyUnit">{{ $t('lang.k_130009') }}</span>
                <span class="withdraw" @click="cash('redpacket')">
                  {{ incomeInfo.in_red_withdraw ? $t('lang.k_130011') : $t('lang.k_130012') }}
                </span>
                <vh-tooltip effect="dark" placement="right" v-tooltipMove>
                  <div slot="content">
                    {{ $t('lang.k_130027') }}
                    <br />
                    {{ $t('lang.k_130028') }}
                    <br />
                    {{ $t('lang.k_130015') }}
                    <br />
                    {{ $t('lang.k_130016') }}
                    <br />
                    <!-- prettier-ignore -->
                    {{ $t('lang.k_130017') }}
                    <br />
                    {{ $t('lang.k_130018') }}
                    <br />
                    {{ $t('lang.k_130019') }}
                    <br />
                    {{ $t('lang.k_130020') }}
                    <br />
                    {{ $t('lang.k_130029') }}
                    <br />
                    {{ $t('lang.k_130022') }}
                    <br />
                    {{ $t('lang.k_130023') }}
                    <br />
                    {{ $t('lang.k_130024') }}
                    <br />
                    {{ $t('lang.k_130025') }}
                  </div>
                  <i class="iconfont-v3 saasicon_help_m"></i>
                </vh-tooltip>
              </p>
              <h1 class="custom-font-barlow">{{ incomeInfo.red_packet_balance | formatMoney }}</h1>
            </div>
          </div>
        </div>
      </vh-col>
    </vh-row>

    <div class="listTab box-card">
      <vh-tabs v-model="activeIndex" @tab-click="handleClick">
        <vh-tab-pane :label="$t('lang.k_130030')" name="1"></vh-tab-pane>
        <vh-tab-pane :label="$t('lang.k_130031')" name="2"></vh-tab-pane>
        <div class="search-income">
          <search-area
            :isForbidExport="!tableList.length"
            ref="searchIncome"
            @onExportData="exportAccount()"
            :searchAreaLayout="searchAccount"
            @onSearchFun="getSearchList()"
          ></search-area>
        </div>
        <table-list
          ref="tableIncome"
          :manageTableData="tableList"
          :tabelColumnLabel="tabelColumn"
          :isCheckout="false"
          :isHandle="isHandle"
          :tableRowBtnFun="tableRowBtnFun"
          :totalNum="totalNum"
          :width="100"
          @onHandleBtnClick="onHandleBtnClick"
          @getTableList="getIncomeList"
        ></table-list>
        <noData :nullType="'nullData'" v-if="!totalNum" :text="$t('lang.k_130032')"></noData>
      </vh-tabs>
    </div>
    <cash-box ref="cashBox" :money="money" :type="type" @onreload="onreload"></cash-box>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle';
  import cashBox from './components/cashBox';
  import { sessionOrLocal } from '@/utils/utils';
  import noData from '@/views/PlatformModule/Error/nullPage';
  export default {
    name: 'income',
    data() {
      return {
        activeIndex: '1',
        totalNum: 1,
        money: 0,
        phone: 0,
        type: 0,
        params: {},
        isHandle: true,
        incomeInfo: {},
        searchAccount: [
          {
            type: '2',
            key: 'searchTime'
          },
          {
            key: 'webinar_name'
          }
        ],

        isCheckout: false,
        tableList: [],
        tabelColumn: [],
        liveColumns: [
          {
            label: this.$t('lang.k_130033'),
            key: 'webinar_id',
            width: 130
          },
          {
            label: this.$t('lang.k_130034'),
            key: 'name',
            customTooltip: true
          },
          {
            label: this.$t('lang.k_130035'),
            key: 'total_income',
            width: 120
          },
          {
            label: this.$t('lang.k_130036'),
            key: 'ticket_income',
            width: 135
          },
          {
            label: this.$t('lang.k_130037'),
            key: 'reward_income',
            width: 135
          },
          {
            label: this.$t('lang.k_130038'),
            key: 'gifts_income',
            width: 135
          }
        ],

        meneyColumns: [
          {
            label: this.$t('lang.k_130033'),
            key: 'webinar_id',
            width: 130
          },
          {
            label: this.$t('lang.k_130034'),
            key: 'name',
            customTooltip: true
          },
          {
            label: this.$t('lang.k_130039'),
            key: 'red_packet_user',
            width: 300
          },
          {
            label: this.$t('lang.k_130040'),
            key: 'red_packet',
            width: 135
          },
          {
            label: this.$t('lang.k_130041'),
            key: 'created_at',
            width: 170
          },
          {
            label: this.$t('lang.k_130042'),
            key: 'money',
            width: 135
          }
        ],

        tableRowBtnFun: [
          {
            name: this.$t('lang.k_130043'),
            methodName: 'detail'
          }
        ]
      };
    },
    components: {
      cashBox,
      PageTitle,
      noData
    },
    created() {
      this.tabelColumn = this.liveColumns;
      this.userId = JSON.parse(sessionOrLocal.get('userId'));
    },
    mounted() {
      this.getIncomeInfo();
      this.getIncomeList();
    },
    watch: {
      activeIndex(value) {
        if (parseInt(value) === 2) {
          this.isHandle = false;
          this.tabelColumn = this.meneyColumns;
        } else {
          this.isHandle = true;
          this.tabelColumn = this.liveColumns;
        }
      }
    },
    methods: {
      getIncomeInfo() {
        this.$fetch('incomeInfo', { user_id: this.userId })
          .then(res => {
            this.incomeInfo = res.data;
          })
          .catch(e => {
            console.log(e);
          });
      },
      onHandleBtnClick(val) {
        let methodsCombin = this.$options.methods;
        methodsCombin[val.type](this, val);
      },
      handleClick(tab) {
        this.activeIndex = tab.name;
        this.$refs.searchIncome.searchParams = {};
        this.$refs.tableIncome.pageInfo.pageNum = 1;
        this.$refs.tableIncome.pageInfo.pos = 0;
        this.getIncomeList();
        this.$vhall_paas_port({
          k: this.activeIndex == 1 ? 100757 : 100758,
          data: {
            business_uid: this.userId,
            user_id: '',
            webinar_id: '',
            refer: '',
            s: '',
            report_extra: {},
            ref_url: '',
            req_url: ''
          }
        });
      },
      getSearchList() {
        let formParams = this.$refs.searchIncome.searchParams;
        if (formParams.webinar_name) {
          this.$vhall_paas_port({
            k: this.activeIndex == 1 ? 100761 : 100762,
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: '',
              refer: '',
              s: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
        }
        this.getIncomeList('search');
      },
      getIncomeList(params) {
        let pageInfo = this.$refs.tableIncome.pageInfo; //获取分页信息
        let formParams = this.$refs.searchIncome.searchParams; //获取搜索参数
        let paramsObj = {};
        if (params === 'search') {
          pageInfo.pageNum = 1;
          pageInfo.pos = 0;
        }
        for (let i in formParams) {
          if (i === 'searchTime' && formParams.searchTime) {
            paramsObj['start_time'] = formParams[i][0];
            paramsObj['end_time'] = formParams[i][1];
          } else {
            paramsObj[i] = formParams[i];
          }
        }
        paramsObj.user_id = this.userId;
        let obj = Object.assign({}, pageInfo, paramsObj);
        this.params = paramsObj;
        let url = this.activeIndex == '1' ? 'liveIncomeList' : 'packetIncomeList';
        this.$fetch(url, obj)
          .then(res => {
            this.totalNum = res.data.total;
            this.tableList = res.data.list;
            if (this.activeIndex == '2') {
              this.rowsList(this.tableList);
            }
            console.log(res);
          })
          .catch(e => {
            console.log(e);
          });
      },
      rowsList(data) {
        data.map(item => {
          item.red_packet =
            item.red_packet_type == '1' ? this.$t('lang.k_130044') : this.$t('lang.k_130045');
        });
      },
      cash(titleKey) {
        this.$vhall_paas_port({
          k: titleKey === 'live' ? 100751 : 100755,
          data: {
            business_uid: this.userId,
            user_id: '',
            webinar_id: '',
            refer: '',
            s: '',
            report_extra: {},
            ref_url: '',
            req_url: ''
          }
        });
        this.userInfo = JSON.parse(sessionOrLocal.get('userInfo'));
        if (this.incomeInfo.in_live_withdraw || this.incomeInfo.in_red_withdraw) {
          this.$vhAlert(this.$t('lang.k_130046'), this.$t('lang.k_130047'), {
            confirmButtonText: this.$t('lang.k_130048'),
            lockScroll: false,
            customClass: 'zdy-message-box',
            callback: action => {}
          });
          return;
        }
        if (titleKey === 'live' && parseInt(this.incomeInfo.live_balance) < 1) {
          this.$vhMessage.warning(this.$t('lang.k_130049'));
          return false;
        }
        if (titleKey === 'redpacket' && parseInt(this.incomeInfo.red_packet_balance) < 1) {
          this.$vhMessage.warning(this.$t('lang.k_130049'));
          return false;
        }
        this.checkWithdrawalToB(titleKey);
      },
      checkWithdrawalToB(titleKey) {
        this.$fetch('checkWithdrawalToB', {})
          .then(res => {
            if (res && res.code == 200 && res.data) {
              if (res.data.is_oauth == 1) {
                sessionOrLocal.set('cashWechat', JSON.stringify(res.data));
                // 已绑定，且有微信昵称 + 头像，不需要授权
                this.$refs.cashBox.dialogCashVisible = true;
                this.phone = this.userInfo.phone;
                this.money =
                  titleKey === 'live'
                    ? this.incomeInfo.live_balance
                    : this.incomeInfo.red_packet_balance;
                this.type = titleKey === 'live' ? 0 : 1;
              } else {
                // 未绑定 或者 微信昵称 和 头像任一一个未拿取到数据，需要授权
                this.$refs.cashBox.dialogVisible = true;
              }
            } else {
              this.$vhMessage.error(res.msg || this.$t('lang.k_130050'));
            }
          })
          .catch(res => {
            this.$vhMessage.error(res.msg || this.$t('lang.k_130050'));
          });
      },
      onreload() {
        this.getIncomeInfo();
      },
      detail(that, { rows }) {
        if (rows.player == 1) {
          that.$vhMessage.warning(that.$t('lang.k_130051'));
          return;
        }
        if (that.activeIndex == 1) {
          that.$vhall_paas_port({
            k: 100763,
            data: {
              business_uid: that.userId,
              user_id: '',
              webinar_id: '',
              refer: '',
              s: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
        }

        that.$router.push({
          path: `/plan/incomeDetail/${rows.webinar_id}`
        });
      },
      // 提现明细
      accountDetail() {
        this.$vhall_paas_port({
          k: 100750,
          data: {
            business_uid: this.userId,
            user_id: '',
            webinar_id: '',
            refer: '',
            s: '',
            report_extra: {},
            ref_url: '',
            req_url: ''
          }
        });
        this.$router.push({
          path: '/plan/accountDetail'
        });
      },
      // 导出收益明细
      exportAccount() {
        let url = this.activeIndex == '1' ? 'exportLiveIncome' : 'exportRedPacket';
        this.$fetch(url, this.params)
          .then(res => {
            this.$vhall_paas_port({
              k: this.activeIndex == 1 ? 100759 : 100760,
              data: {
                business_uid: this.userId,
                user_id: '',
                webinar_id: '',
                refer: '',
                s: '',
                report_extra: {},
                ref_url: '',
                req_url: ''
              }
            });
            this.$vhMessage({
              message: this.$t('lang.k_130052', [
                this.activeIndex == '1' ? this.$t('lang.k_130053') : this.$t('lang.k_130054'),
                this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_130055')
              ]),

              showClose: true,
              // duration: 0,
              type: 'success',
              customClass: 'zdy-info-box'
            });
            this.$EventBus.$emit('saas_vs_download_change');
          })
          .catch(res => {
            this.$vhMessage({
              message:
                res.msg ||
                this.$t('lang.k_130056', [
                  this.activeIndex == '1' ? this.$t('lang.k_130053') : this.$t('lang.k_130054')
                ]),
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          });
      }
    }
  };
</script>

<style lang="less" scoped>
  .account-income {
    position: relative;
    .box-card {
      background: #fff;
      padding: 0 0 40px 0;
      border-radius: 4px;
    }
    .detail {
      position: absolute;
      top: 8px;
      right: 0;
      color: #3b67f9;
      font-size: 14px;
      cursor: pointer;
    }
    .live-come {
      padding: 24px 32px;
      border-radius: 4px;
      background: #fff;
      // margin-right: 10px;
      height: 170px;
      h3 {
        font-size: 16px;
        color: #1a1a1a;
        font-weight: 400;
        padding-bottom: 26px;
      }
    }
    .live-all {
      display: flex;
      .all-come {
        width: 50%;
        padding-left: 24px;
        p {
          font-size: 14px;
          color: #999;
          font-weight: 400px;
          padding-bottom: 8px;
        }
        h1 {
          font-size: 28px;
          color: #1a1a1a;
          font-weight: bold;
          line-height: 32px;
        }
        .withdraw {
          padding: 2px 8px;
          border-radius: 10px;
          border: 1px solid #fb3a32;
          font-size: 12px;
          color: #fb3a32;
          cursor: pointer;
        }
        .moneyUnit {
          padding: 0 6px 0 8px;
        }
        i {
          font-size: 14px;
          padding: 0 5px;
          color: #1a1a1a;
          &.saasicon_help_m {
            color: #999;
          }
        }
      }
    }
    .money-come {
      margin-left: 16px;
      height: 170px;
      padding: 24px 32px;
      border-radius: 4px;
      background: #fff;
      h3 {
        font-size: 16px;
        color: #1a1a1a;
        font-weight: 400;
        padding-bottom: 26px;
      }
    }
    .listTab {
      margin-top: 24px;
      .search-income {
        margin-top: 32px;
      }
    }
  }
  /deep/.saasicon_help_m {
    color: #999999;
  }
</style>
